import {createSelector} from 'reselect';

import useCancellationPolicy from './cancellationPolicy';
import {getListingLabels} from './listingLabels';
import {getListingSummary} from './listingSummary';
import {getFirstPayment, getPriceLabels, getTotals} from './priceDetails';
import {getSiteName} from './system';
import {
    isDatePickerModalOpen,
    isGuestSelectorModalOpen,
    isRequestToBookModalOpen,
    isInquiryModalOpen
} from './modalStates';
import {getBookingType, getTakesInquiries} from './listing';
import {getTravelerFeatures} from './store';

const getViewDetailsTotalData = createSelector(
    [getPriceLabels, getTotals],
    (labels, totals) => ({
        labels,
        showViewDetailsLink: !!(totals || /* istanbul ignore next */ {}).totalWithoutDeposits,
        totals
    })
);

const getRightRailData = createSelector(
    [
        useCancellationPolicy,
        getBookingType,
        getListingLabels,
        getListingSummary,
        getViewDetailsTotalData,
        getSiteName,
        isDatePickerModalOpen,
        isGuestSelectorModalOpen,
        isRequestToBookModalOpen,
        isInquiryModalOpen,
        getTakesInquiries,
        getTravelerFeatures,
        getFirstPayment
    ],
    (
        cancellationPolicy,
        bookingType,
        listingLabels,
        listingSummary,
        viewDetailsTotalData,
        siteName,
        datePickerPopoverOpen,
        guestSelectorPopoverOpen,
        requestToBookModalOpen,
        inquiryModalOpen,
        takesInquiries,
        travelerFeatures,
        firstPaymentData
    ) => {
        return {
            cancellationPolicy,
            listingLabels,
            listingSummaryData: listingSummary,
            viewDetailsTotalData,
            propertyOlb: bookingType.onlineBookable,
            siteName,
            datePickerPopoverOpen,
            guestSelectorPopoverOpen,
            requestToBookModalOpen,
            inquiryModalOpen,
            showSecondaryAction: bookingType.onlineBookable && takesInquiries,
            displayBookingAssistance: travelerFeatures.displayBookingAssistance,
            firstPaymentData
        };
    }
);

export default getRightRailData;
export {getRightRailData, getViewDetailsTotalData};
